module.exports = __webpack_public_path__ + "static/media/bg_desktop.116f673e.mp4";